<template src="./vehiclesorn.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
export default {
  props: ["NewTrailer"],
  methods: {
    SornVehicle(vehicle_id) {
      var vehicleType =
        this.NewTrailer.class == "Trailer" ? "Trailer" : "Vehicle";
      this.$swal
        .fire({
          title: "Sorn " + vehicleType,
          text:
            "You are about to mark this " +
            vehicleType +
            " as sorn " +
            vehicleType,
          //icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continue",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.Sorn, {
              token: localStorage.getItem("token"),
              vehicle_id: vehicle_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.$parent.LoadProfileData();
                this.$swal
                  .fire(
                    vehicleType +
                      " Mark as Sorned " +
                      vehicleType +
                      " Successfully",
                    "",
                    "success"
                  )
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    UnSornVehicle(vehicle_id) {
      var vehicleType =
        this.NewTrailer.class == "Trailer" ? "Trailer" : "Vehicle";
      this.$swal
        .fire({
          title: "Unsorn " + vehicleType,
          text:
            "You are about to mark this " +
            vehicleType +
            " as Unsorn " +
            vehicleType,
          //icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continue",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.Unsorn, {
              token: localStorage.getItem("token"),
              vehicle_id: vehicle_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.$parent.LoadProfileData();
                this.$swal
                  .fire(
                    vehicleType + " Mark as Unsorn " + vehicleType,
                    "",
                    "success"
                  )
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 991px) {
  .width-full {
    width: 100% !important;
  }
}
</style>
